import React, { useContext, useState } from "react";
import PsContext from "../../context";

import { useNavigate } from "react-router-dom";
import V2SinglePassword from "./v2SinglePassword";
import V2SingleUsername from "./v2SingleUsername";
import { Col, Row } from "react-bootstrap";

const LoginV2Single = (props) => {
  const context = useContext(PsContext);
  const navigation = useNavigate();
  const [loader, setLoader] = useState(false);
  const [employee, setEmployee] = useState(false);

  const getEmployeeData = () => {
    let s = [];
    s.uuid = context.mobileUserId;
    s.employee_name = context.getStorage("employee_name");
    return s;
  };

  const resetEmployee = () => {
    setEmployee([]);
  };

  return (
    <>
      <div className="">
        <div className="container-sm">
          <Row>
            <Col md={{ offset: 2, span: 8 }}>
              {context.mobileUserId.length > 4 ? (
                <>
                  <V2SinglePassword employeeSource={getEmployeeData()} />
                </>
              ) : (
                <>
                  {!employee.uuid && (
                    <V2SingleUsername onSuccess={(d) => setEmployee(d)} />
                  )}
                  {employee.uuid && (
                    <V2SinglePassword
                      onSuccess={(d) => setEmployee(d)}
                      employeeSource={employee}
                      onCancel={(d) => resetEmployee()}
                    />
                  )}
                </>
              )}
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
export default LoginV2Single;
